import React from "react";
import { TfiClose } from "react-icons/tfi";
import {
  cart,
  List,
  cart_MA,
  Linkoption,
  linkoption_MA,
  media_MA,
  Media,
  cart_Zyia,
  cart_Beyound,
  cart_Yoli,
  media_Zyia,
  media_Beyound,
  media_Yoli,
  linkoption_Zyia,
  linkoption_Beyound,
  linkoption_Yoli,
  cart_default,
  media_default,
  linkoption_default,
  cart_Tranont,
  linkoption_Tranont,
  media_Tranont,
  cart_PartnerCo,
  media_PartnerCo,
  linkoption_PartnerCo,
} from "../../../../assets/icons";
import useAppAccessor from "../../../../hooks/useappAccessor";
import { getBrandColor } from "../../../../utils/brand.util";

const InteractionsOptions = (props: any) => {
  const { getUserData } = useAppAccessor();
  const { user, client } = getUserData();
  const { publicUserData } = user;
  const { language } = getUserData();

  const OptionIconRow = ({
    name = "",
    iconName = "",
    type = "",
    mtValue = 0,
  }: {
    name?: string;
    iconName: any;
    type?: string;
    mtValue?: number;
  }) => {
    return (
      <>
        <div
          className="rounded-lg border-[1px] text-center flex flex-col items-center justify-center cursor-pointer"
          style={{
            height: 120,
            width: 120,
            borderColor: `${getBrandColor(client)} `,
          }}
          onClick={() => {
            props.handleOptionsClick(type);
          }}
        >
          <img
            src={iconName}
            alt="Icon"
            height={45}
            width={45}
            style={{ fill: `${getBrandColor(client)} ` }}
          />
          <span
            className="text-[22px] font-bold"
            style={{ marginTop: mtValue, color: `${getBrandColor(client)}` }}
          >
            {name}
          </span>
        </div>
      </>
    );
  };

  const checkShopIcon = (client: any) => {
    switch (client) {
      case "marketamerica": {
        return cart_MA;
      }
      case "zyiaactive": {
        return cart_Zyia;
      }
      case "beyondslim": {
        return cart_Beyound;
      }
      case "Yoli": {
        return cart_Yoli;
      }
      case "Verb": {
        return cart_default;
      }
      case "Hussle": {
        return cart_default;
      }
      case "tranont": {
        return cart_Tranont;
      }
      case "partner.co": {
        return cart_PartnerCo;
      }

      default:
        return cart;
    }
  };
  const checkMediaIcon = (client: any) => {
    switch (client) {
      case "marketamerica": {
        return media_MA;
      }
      case "zyiaactive": {
        return media_Zyia;
      }
      case "beyondslim": {
        return media_Beyound;
      }
      case "Yoli": {
        return media_Yoli;
      }
      case "Verb": {
        return media_default;
      }
      case "Hussle": {
        return media_default;
      }
      case "tranont": {
        return media_Tranont;
      }
      case "partner.co": {
        return media_PartnerCo;
      }
      default:
        return Media;
    }
  };
  const checkLinkIcon = (client: any) => {
    switch (client) {
      case "marketamerica": {
        return linkoption_MA;
      }
      case "zyiaactive": {
        return linkoption_Zyia;
      }
      case "beyondslim": {
        return linkoption_Beyound;
      }
      case "Yoli": {
        return linkoption_Yoli;
      }
      case "Verb": {
        return linkoption_default;
      }
      case "Hussle": {
        return linkoption_default;
      }
      case "tranont": {
        return linkoption_Tranont;
      }
      case "partner.co": {
        return linkoption_PartnerCo;
      }
      default:
        return Linkoption;
    }
  };

  return (
    <div className="h-full w-full relative">
      <div
        className="flex   h-10 items-center absolute right-4 top-3 "
        onClick={() => {
          props.handleCloseclick();
        }}
      >
        <TfiClose color="#DEDEDE" size={20} cursor="pointer" />
      </div>

      <div
        className="h-full w-full flex flex-col items-center justify-center"
        style={{ backgroundColor: "#181818" }}
      >
        <div>
          <div className="flex">
            {publicUserData?.isMAUser &&
              publicUserData.company_name.indexOf("L’BRI") == -1 && 
              publicUserData.company_name.indexOf("E-Excel") == -1 && 
              (
                <OptionIconRow
                  name={language["sell"]}
                  iconName={checkShopIcon(client)}
                  mtValue={5}
                  type="A"
                ></OptionIconRow>
              )}
            {publicUserData?.isMAUser &&
              publicUserData.company_name.indexOf("L’BRI") == -1 &&
              publicUserData.company_name.indexOf("E-Excel") == -1 && 
              publicUserData?.isCRMUser && <div className="h-3.5 w-3.5"></div>}
            {publicUserData?.isCRMUser && (
              <OptionIconRow
                name={language["media"]}
                iconName={checkMediaIcon(client)}
                mtValue={5}
                type="B"
              ></OptionIconRow>
            )}
          </div>
          <div className="h-3.5"></div>

          { !publicUserData?.community_content_creator && <div className="flex justify-center">
            <OptionIconRow
              name={language["link"]}
              iconName={checkLinkIcon(client)}
              mtValue={5}
              type="C"
            ></OptionIconRow>
            {/* <div className="h-3.5 w-3.5"></div>
            <OptionIconRow
              name="Saved"
              iconName={List}
              mtValue={7}
              type="D"
            ></OptionIconRow> */}
          </div>}
        </div>
      </div>
    </div>
  );
};

export default InteractionsOptions;
